import { useState, useEffect } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { httpRequest } from '@calendly/http-tools'

import { useGetEventTypeQuery } from 'root-api'

export const usePurchasedPackageForLocale = () => {
  const { profileSlug, packageUuid, purchasedPackageUuid } = useParams()
  const location = useLocation()
  const [purchased, setPurchased] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const statePackage = location.state?.purchasedPackage
    if (statePackage) {
      setPurchased(statePackage)
      setLoading(false)
      return
    }

    if (!profileSlug || !packageUuid || !purchasedPackageUuid) {
      setLoading(false)
      return
    }

    const fetchPurchasedPackage = async () => {
      try {
        const [ok, res] = await httpRequest({
          url: `/api/booking/purchased_packages/${purchasedPackageUuid}`,
          method: 'GET',
        })

        if (ok && res?.resource) {
          setPurchased(res.resource)
        }
      } finally {
        setLoading(false)
      }
    }

    fetchPurchasedPackage()
  }, [profileSlug, packageUuid, purchasedPackageUuid, location.state?.purchasedPackage])

  const eventTypeUuid = purchased?.purchased_package_items?.[0]?.item_uuid

  const { data: eventType, isLoading: isEventTypeLoading } = useGetEventTypeQuery(
    { eventTypeUuid },
    { skip: !eventTypeUuid },
  )

  const isWaitingForEventType = eventTypeUuid && isEventTypeLoading

  return {
    loading: loading || isWaitingForEventType,
    eventType,
    purchasedPackage: purchased,
  }
}
